//  ----------      START   IMPORT  BLOCK       ----------
//  Widgets
import ImageRowWidget from '../ImageRowWidget/ImageRowWidget';
import SocialsWidget from '../Socials/SocialsWidget';
//  Config
import {VocabAboutContent as vocab} from '../../../../../ConfigFiles/multilingual/VocabAboutContent';
//  ----------      END   IMPORT  BLOCK       ----------

export const getAboutContents = (lan) => {
  return [
    {
      id: vocab.companny_section_id[lan],
      title: vocab.companny_section_title[lan],
      chapters: [
        {
          id: vocab.background_id[lan],
          title: vocab.background_title[lan],
          body: vocab.background_body[lan],
          widget: (
            <ImageRowWidget
              images={[
                'https://i.pinimg.com/564x/45/8f/ef/458fef941245dcf1c786ec055318b9d3.jpg',
                'https://i.kym-cdn.com/photos/images/original/002/477/589/f83.jpg',
                'https://pbs.twimg.com/media/EpmCPjYXEAcQpmS.png',
              ]}
            />
          ),
        },
        {
          id: vocab.vision_id[lan],
          title: vocab.vision_title[lan],
          body: vocab.vision_body[lan],
          widget: (
            <ImageRowWidget
              images={[
                'https://i.pinimg.com/564x/45/8f/ef/458fef941245dcf1c786ec055318b9d3.jpg',
                'https://i.kym-cdn.com/photos/images/original/002/477/589/f83.jpg',
                'https://pbs.twimg.com/media/EpmCPjYXEAcQpmS.png',
              ]}
            />
          ),
        },
        {
          id: vocab.mission_id[lan],
          title: vocab.mission_title[lan],
          body: vocab.mission_body[lan],
          widget: (
            <ImageRowWidget
              images={[
                'https://i.pinimg.com/564x/17/0a/81/170a81140c6465739ed1e81ff55a62c9.jpg',
              ]}
            />
          ),
        },
        {
          id: vocab.name_origin_id[lan],
          title: vocab.name_origin_title[lan],
          body: vocab.name_origin_body[lan],
          widget: (
            <ImageRowWidget
              images={[
                'https://upload.wikimedia.org/wikipedia/commons/thumb/5/57/Caduceus.svg/500px-Caduceus.svg.png',
                'https://upload.wikimedia.org/wikipedia/commons/7/75/Pierre_Mignard_-_Clio_-_WGA15654.jpg',
                'https://upload.wikimedia.org/wikipedia/commons/3/36/Menglöð_and_Nine_Maidens_by_Froelich.jpg'
              ]}
            />
          ),
        },
        
      ],
    },
    {
      id: vocab.philosophy_section_id[lan],
      title: vocab.philosophy_section_title[lan],
      
      chapters: [
        {
          id: vocab.mexico_id[lan],
          title: vocab.mexico_title[lan],
          body: vocab.mexico_body[lan],
            widget: (
            <ImageRowWidget
              images={[
                'https://i.pinimg.com/564x/36/fe/3c/36fe3ce9b219cd63de51fd284ac92c57.jpg',
              ]}
            />
          ),
        },
        {
          id: vocab.patients_id[lan],
          title: vocab.patients_title[lan],
          body: vocab.patients_body[lan],
                    widget: (
            <ImageRowWidget
              images={[
                'https://i.pinimg.com/564x/3b/c8/d1/3bc8d169dd59341e9afaa0c95506a4f9.jpg',
              ]}
            />
          ),
        },
        {
          id: vocab.professionals_id[lan],
          title: vocab.professionals_title[lan],
          body: vocab.professionals_body[lan],
                    widget: (
            <ImageRowWidget
              images={[
                'https://static.wikia.nocookie.net/94723ec1-7dda-4645-bda5-43aaf326854a',
              ]}
            />
          ),
        },
        {
          id: vocab.pharmaceutical_id[lan],
          title: vocab.pharmaceutical_title[lan],
          body: vocab.pharmaceutical_body[lan],
                    widget: (
            <ImageRowWidget
              images={[
                'https://i.pinimg.com/564x/6e/77/d3/6e77d3d3f877ef782edc1c09a6d24c26.jpg',
              ]}
            />
          ),
        },

      ],
    },
    {
      id: vocab.our_team_id[lan],
      title: vocab.our_team_title[lan],
      chapters: [
        {
          id: vocab.our_team_id[lan],
          title: vocab.our_team_title[lan],
          body: vocab.our_team_body[lan],
                    widget: (
            <ImageRowWidget
              images={[
                'https://static.wikia.nocookie.net/ab93bbe3-32fa-4854-a89d-fd84340f3607/',
              ]}
            />
          ),
        },
      ],
    },
    {
      id: vocab.contact_section_id[lan],
      title: vocab.contact_section_title[lan],
      chapters: [
        {
          id: vocab.contact_id[lan],
          title: vocab.contact_title[lan],
          body: <SocialsWidget/>,
          widget: (
            <ImageRowWidget
              images={[]}
            />
          ),
        },
      ],
    },
  ];
};
